import { createApp } from 'vue/dist/vue.esm-bundler';
import router from './router'
import Lang from 'lang.js'
import translations from '../assets/js/ll_messages'
import Store from './store'
import AWN from 'awesome-notifications'
import VueUniversalModal from 'vue-universal-modal'
import vSelect from 'vue-select'
import Highcharts from 'highcharts'
import Stock from 'highcharts/modules/stock'
import Bullet from 'highcharts/modules/bullet'
import VariablePie from 'highcharts/modules/variable-pie'
import Boost from 'highcharts/modules/boost'
import StockTools from 'highcharts/modules/stock-tools'
import DragPanes from 'highcharts/modules/drag-panes'
import AnnotationsAdvanced from 'highcharts/modules/annotations-advanced'
import Indicators from 'highcharts/indicators/indicators-all'
import HighchartsVue from 'highcharts-vue'
import PerfectScrollbar from 'vue3-perfect-scrollbar'
import Vue3ColorPicker from 'vue3-colorpicker'
import 'vue3-colorpicker/style.css'
import pusherJs from 'pusher-js'
import axios from 'axios'
import { isTenant, getBroadcastTenant, initializeEcho, sanitizeTenantId } from './helpers/general'
import { echoService } from './services/echo.service';

window.Pusher = pusherJs

window.axios = axios

window.axios.defaults.headers.common['Accept'] = 'application/json'

// Add this after axios initialization
window.axios.defaults.withCredentials = true;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// initializeEcho();
echoService.initialize();

const token = localStorage.getItem('token')
const tenant = localStorage.getItem('tenant')
if (token) {
  window.axios.defaults.headers.common.Authorization = `Bearer ${token}`
}

if (tenant) {
  console.log(tenant)
  window.axios.defaults.headers.common['X-Tenant-ID'] = tenant
} else {
  const broadcastTenant = getBroadcastTenant()
  if (broadcastTenant != 'central') {
    localStorage.setItem('tenant', broadcastTenant)
    window.axios.defaults.headers.common['X-Tenant-ID'] = broadcastTenant
  }
}

const redirectToRoute = (redirect) => {
  // console.log('remove me', redirect)
  // return;
  switch (redirect) {
    case "select-tenant":
      if (isTenant()) {
        window.location.href = `https://${import.meta.env.VITE_CENTRAL_DOMAIN}/auth/select-tenant`;
      } else {
        router.push('/auth/select-tenant')
      }
      break;

    case "current-tenant":
      if (!window.axios.defaults.headers.common['X-Tenant-ID']) {
        window.location.href = `https://${import.meta.env.VITE_CENTRAL_DOMAIN}`
      } else {
        window.location.href = `https://${sanitizeTenantId(window.axios.defaults.headers.common['X-Tenant-ID'])}.${import.meta.env.VITE_CENTRAL_DOMAIN}`
      }
      break;

    case "unverified":
      if (isTenant()) {
        window.location.href = `https://${import.meta.env.VITE_CENTRAL_DOMAIN}/auth/verify-email`;
      } else {

        router.push('/auth/verify-email');
      }
      break;

    case "login":
      if (isTenant()) {
        window.location.href = `https://${import.meta.env.VITE_CENTRAL_DOMAIN}/auth/login`;
      } else {
        router.push('/auth/login');
      }
      break;
    default:
      break;
  }
}

window.axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

window.axios.interceptors.response.use(response => {
  if ('data' in response && typeof response.data == 'object') {
    if (response.data && "redirect" in response.data) {
        redirectToRoute(response.data.redirect)
    }
  }
  return response;
}, async error => {
  const originalRequest = error.config;

  console.log('Response error:', {
    status: error.response?.status,
    url: originalRequest.url,
    headers: originalRequest.headers,
    retry: originalRequest._retry
  });

  if (originalRequest.url === '/api/refresh-token') {
    return Promise.reject(error);
  }

  if (error.response?.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;

    try {
      console.log('Attempting token refresh');
      const response = await axios.post(`${window.location.origin}/api/refresh-token`, {}, {
        withCredentials: true,
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      console.log('Token refresh response:', response.data);

      const newToken = response.data.access_token;

        echoService.updateToken(newToken);

        // Update authorization headers
      window.axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;

      // Update Echo auth if it exists
      if (window.Echo) {
        window.Echo.connector.options.auth.headers['Authorization'] = `Bearer ${newToken}`;
      }

      // Retry the original request
      console.log('Retrying original request:', {
        url: originalRequest.url,
        headers: {
          ...originalRequest.headers,
          'Authorization': `Bearer ${newToken}`
        }
      });

      return window.axios({
        ...originalRequest,
        headers: {
          ...originalRequest.headers,
          'Authorization': `Bearer ${newToken}`
        }
      });

    } catch (refreshError) {
      console.error('Token refresh failed:', refreshError.response?.data);

      // Clear auth state
      localStorage.removeItem('token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('tenant');

      // Update store
      Store.commit('auth/SET_AUTHENTICATED', false);
      Store.commit('auth/SET_USER', null);
      Store.commit('auth/SET_SELECTED_TENANT', null);
      Store.commit('auth/SET_TOKEN', null);

      // Redirect to login on central domain
      if (isTenant()) {
        window.location.href = `https://${import.meta.env.VITE_CENTRAL_DOMAIN}/auth/login`;
      }
      return Promise.reject(refreshError);
    }
  }
  if (error.response.status === 400) {
    if (error.response.data && "redirect" in error.response.data) {
      redirectToRoute(error.response.data.redirect)
    }
  }
  // if (error.response.status === 401) {
  //   localStorage.removeItem('token')
  //   if (isTenant()) {
  //     window.location.href = `https://${import.meta.env.VITE_CENTRAL_DOMAIN}/auth/login`;
  //   } else {
  //     router.push({ path: '/auth/login' })
  //   }
  // }
  if (error.response.status === 403) {
    if (error.response.data && "redirect" in error.response.data) {
      redirectToRoute(error.response.data.redirect)
    }
  }
  return Promise.reject(error);
});

const trans = new Lang({
  messages: translations,
  locale: window.default_locale,
  fallback: window.fallback_locale
})

window.trans = trans

const notifierOptions = {
  messages: {
    async: trans.get('notify.loadingNotification'),
  },
  labels: {
    tip: trans.get('labels.tip'),
    info: trans.get('labels.info'),
    success: trans.get('labels.success'),
    warning: trans.get('labels.warning'),
    alert: trans.get('labels.alert'),
    async: trans.get('labels.async'),
  }
}

const notifier = new AWN(notifierOptions)

const app = createApp({})
app.provide('$trans', trans)
app.provide('$notify', notifier)
app.provide('tenantBrand', {
  logo: window.ecBrandLogo,
  logoOnly: window.ecBrandLogoOnly
})

app.use(Vue3ColorPicker)
app.use(router)
app.use(Store)
app.use(PerfectScrollbar)
app.use(VueUniversalModal, {
  teleportTarget: '#modals'
})
Stock(Highcharts);
Bullet(Highcharts);
VariablePie(Highcharts);
Boost(Highcharts);
DragPanes(Highcharts);
Indicators(Highcharts);
AnnotationsAdvanced(Highcharts);
StockTools(Highcharts);
app.use(HighchartsVue);

app.component('v-select', vSelect)

app.mount('#app')
